export const downloadBuilder = (url?: string, filename?: string | null) => {
  if (!url) return
  window.open(route('v2.forceDownload', { _query: { file: url, filename } }))
}
